export default __webpack_public_path__ + "static/media/invision.dab78dfd.svg";